// store/reducers/profileReducer.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';
import api from '../../axiosConfig';
import domain from '../../constants/config.js';

const apiDomain = domain.API_BASE_URL;

// Thunks
export const checkCustomer = createAsyncThunk(
  'profile/checkCustomer',
  async (data) => {
    try {
        const { mobile, web = false, src = '', clnt = ''} = data;

        console.log("mobilemobilecheckCustomer",mobile);
        console.log("webweb",web);
        console.log("sourcesource",src);
        console.log("clntclient",clnt);

        let apiUrl = `${apiDomain}v1/user-check?mobile=${mobile}`;

        if (web) { // not from mobile app, from web
          apiUrl += `&web=1`;
        }

        if (src) {
          apiUrl += `&src=${src}`;
        }

        if (clnt) {
          apiUrl += `&clnt=${clnt}`;
        }

      console.log("apiUrlapiUrl",apiUrl);
      const response = await api.get(apiUrl);
    //   const response = await axios.post(apiUrl, { mobile });
    console.log("response checkCustomer",response);
      return response.data;
    } catch (error) {
    //   return rejectWithValue(error.response?.data || error.message);
      return error.response?.data || error.message;
    }
  }
);

export const verifyUser = createAsyncThunk(
  'profile/verifyUser',
  async (data) => {
    try {
        const { mobile, web = false, src = '', clnt = ''} = data;

        // console.log("createUser",createUser);
        console.log("verifyUser",mobile);
        console.log("webweb",web);
        console.log("sourcesource",src);
        console.log("clntclient",clnt);

        let apiUrl = `${apiDomain}v1/verify-key?mobile=${mobile}`;

        if (web) { // not from mobile app, from web
          apiUrl += `&web=1`;
        }

        if (src) {
          apiUrl += `&src=${src}`;
        }

        if (clnt) {
          apiUrl += `&clnt=${clnt}`;
        }

        // apiUrl += `&cu=${createUser}`;

      console.log("apiUrlapiUrl",apiUrl);
      const response = await api.get(apiUrl,{
        skipAuth: true
      });
    //   const response = await axios.post(apiUrl, { mobile });
    console.log("response checkCustomer",response);
      return response.data;
    } catch (error) {
    //   return rejectWithValue(error.response?.data || error.message);
      return error.response?.data || error.message;
    }
  }
);
export const saveProfile = createAsyncThunk(
  'profile/saveProfile',
  async (profileRequestData) => {
    try {
      // Get values from localStorage
      const source = JSON.parse(localStorage.getItem('src') || '""');
      const client = JSON.parse(localStorage.getItem('clnt') || '""');

      // Declare payload variable
      let updatedPayload;

      // Merge with existing payload if both values exist
      if (source && client) {
        updatedPayload = {
          ...profileRequestData,
          src: source,
          clnt: client,
        };
      } else {
        updatedPayload = profileRequestData;
      }

      const apiUrl = `${apiDomain}v1/rsa-plans-purchase`;
      const response = await api.post(apiUrl, updatedPayload);
      return response.data;
    } catch (error) {
      return error.response?.data || error.message;
    }
  }
);

export const verifyOtp = createAsyncThunk(
  'profile/verifyOtp',
  async ({ mobile, otp }, { rejectWithValue }) => {
    try {
      const response = await api.post('/api/verifyOtp', { mobile, otp });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getPaymentUrl = createAsyncThunk(
  'profile/getPaymentUrl',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post('/api/getPaymentUrl', data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const verifyRegisterNumber = createAsyncThunk(
  'profile/verifyRegisterNumber',
  async (data) => {
    try {
      const apiUrl = `${apiDomain}v1/karza-service`;
      const response = await api.post(apiUrl,data);
      return response.data;
    } catch (error) {
      return error.response?.data || error.message;
    }
  }
);

// Slice
const profileSlice = createSlice({
  name: 'profileList',
  initialState: {
    data: {},
    paymentUrl: '',
    profileData: null,
    tokenData:null,
    vehicleData:null,
    planPurchasedData:null,
    paymentLink:null,
    otpVerified: false,
    isNewCustomer: false,
    planExistCustomer: false,
    loading: false,
    profileLoader:false,
    vehicleRegLoader:false,
    error: null,
  },
  reducers: {
    setProfile: (state, action) => {
      state.data = action.payload;
    },
    setPaymentUrl: (state, action) => {
      state.paymentUrl = action.payload;
    },
    setProfileFormData: (state, action) => {
      state.formData = action.payload;
    },
    setIsNewCustomer: (state, action) => {
      state.isNewCustomer = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // checkCustomerThunk
      .addCase(checkCustomer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkCustomer.fulfilled, (state, action) => {
        console.log("actionactionactionaction",action);
        state.loading = false;
        state.profileData = action.payload;
        // state.isNewCustomer = false;
        state.planExistCustomer = state.profileData?.sub_customer;
      })
      .addCase(checkCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // VerifyUser
      .addCase(verifyUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyUser.fulfilled, (state, action) => {
        console.log("verifyUser",action);
        state.loading = false;
        state.tokenData = action.payload.data;

          localStorage.setItem(
            'access_token',
            action?.payload?.data?.access_token
          );
      
          localStorage.setItem(
              'refresh_token',
              action?.payload?.data?.refresh_token
          );
      })
      .addCase(verifyUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // verifyOtpThunk
      .addCase(verifyOtp.fulfilled, (state) => {
        state.otpVerified = true;
      })

      // getPaymentUrlThunk
      .addCase(getPaymentUrl.fulfilled, (state, action) => {
        state.paymentUrl = action.payload?.url || '';
      })

      //saveProfileThunk
      .addCase(saveProfile.pending, (state) => {
        state.profileLoader = true;
        state.error = null;
      })
      .addCase(saveProfile.fulfilled, (state, action) => {
        state.profileLoader = false;
        state.planPurchasedData = action.payload; // Save response to `data`
      })
      .addCase(saveProfile.rejected, (state, action) => {
        state.profileLoader = false;
        state.error = action.payload;
      })

      //Karza api response
      .addCase(verifyRegisterNumber.pending, (state) => {
        state.vehicleRegLoader = true;
        state.error = null;
      })
      .addCase(verifyRegisterNumber.fulfilled, (state, action) => {
        state.vehicleRegLoader = false;
        state.vehicleData = action.payload; // Save response to `data`
      })
      .addCase(verifyRegisterNumber.rejected, (state, action) => {
        state.vehicleRegLoader = false;
        state.error = action.payload;
      });
  },
});

export const { setProfile, setPaymentUrl, setProfileFormData, setIsNewCustomer } = profileSlice.actions;
// console.log("setProfile",setProfile);
export default profileSlice.reducer;
